/**
 * QUIÉN ENTRA A PROMOCIONES (db/198 → db/205), y quién hace qué dentro.
 *
 * ── PERÍODO DE PRUEBA: TERMINÓ EL 2026-10-02 ────────────────────────────────
 * Del 01/10 al 02/10 solo la vieron los MASTER y los avisos se anotaban sin
 * mandarse. El 2026-10-02 la usuaria la abrió: «activa lo que ya tenemos
 * construido del módulo de promociones tanto en la app como en el portal …
 * con visibilidad para asesores con sus restricciones, coordinadores con sus
 * restricciones, gerenciaventas, franciscodiaz, trademarketing, cei y master».
 * Preguntada ese día, añadió a Facturación (para CONCLUIR, solo su empresa),
 * activó los correos a la lista de siempre y decidió que Key Accounts vea todo
 * y registre las del 103. La base lo dice en db/205.
 *
 * Una sola copia, y la importan el endpoint (`netlify/functions/promos.mts`), que
 * es el candado de verdad, el menú (`navegacion.ts`) y la página. La app no lleva
 * copia: pregunta por el permiso (`API.puede('promos')`) y por `meta.puede_registrar`.
 *
 * ── QUIÉN HACE QUÉ ──────────────────────────────────────────────────────────
 *  · REGISTRA: el ASESOR, sobre los clientes de SU código (NORMA 1); el COORDINADOR
 *    (rol REGIONAL con códigos en su alcance), sobre los clientes de SU zona, desde el
 *    2026-10-22; Key Accounts (`REGISTRA_COMO_ASESOR`), solo los del 103; y Master.
 *  · VE el registro: el asesor (lo suyo), el coordinador (su zona; Key Accounts
 *    todo, db/161), Gerencia de Ventas, C.E.I. (ANALISTACEI y GERENCIACEI), Trade
 *    Marketing, Facturación (su empresa) y Master (FRANCISCODIAZ es Master).
 *  · CIERRA («concluido»): la Facturación de la EMPRESA del registro, cuando ya se
 *    generó la factura o la NC. Y Master.
 *  · Kenya (cuenta KENYA), Cobranzas y Almacén NO entran: reciben el correo
 *    (Kenya por el buzón de Gerencia de Ventas), pero la usuaria no los nombró.
 */

/** Mientras sea `true`, solo los MASTER entran y no sale ningún correo. Se abrió el 2026-10-02 (db/205). */
export const PROMOS_EN_PRUEBA = false;

/** Los roles que ven la sección (db/205). CUALQUIER cambio aquí va con su migración: la base es la otra puerta.
 *  GERENCIAFINANZAS (las dos cuentas de Finanzas) entra el 2026-10-12 con db/233 SOLO A MIRAR: «todo el módulo
 *  comercial», solo ver. No registra (`puedeRegistrarPromo` no la nombra) ni concluye (`puedeCerrarPromo` es de
 *  Master o de la Facturación de la empresa).
 *  COORDCOMPRASCOSTO (Coordinación de Compras y de Planificación y Costo) entra el 2026-10-12 con db/235, también
 *  SOLO A MIRAR y descargar: la usuaria la nombró («comercial solo … promociones») y el rol es de solo lectura.
 *  REPORTESEXTERNO (Hernán Prato) entra el 2026-10-14 con db/242, SOLO A MIRAR: «Promociones B2B» está en sus diez
 *  reportes y el rol es de solo lectura.
 *  ANALISTATRADEMKT (los dos analistas de Trade, ANALISTATRADESENIOR y ANALISTATRADE) entra el 2026-10-15 con db/245:
 *  la usuaria, «agregar la seccion de promociones solo el registro de promos aceptadas … a los tres usuarios de trade».
 *  db/205 los había dejado fuera a propósito; ahora entran, pero SOLO al registro: ver `ROLES_PROMOS_SOLO_REGISTRO`. */
export const ROLES_PROMOS: readonly string[] = [
  'ASESOR', 'REGIONAL', 'MASTER', 'GERENCIAVENTAS', 'ANALISTACEI', 'GERENCIACEI', 'TRADEMARKETING',
  'FACTURACION', 'FACTURACIONDDH', 'GERENCIAFINANZAS', 'COORDCOMPRASCOSTO', 'REPORTESEXTERNO', 'ANALISTATRADEMKT',
  'CONSULTAGENERAL',   // db/273: la consulta general, SOLO A MIRAR (no registra, no concluye, no anula)
];

/**
 * LOS QUE VEN SOLO EL REGISTRO DE PROMOS ACEPTADAS (db/245, 2026-10-15). Ni el cumplimiento de metas, ni el
 * presupuesto, ni las promos de cada cliente o de la región (las vistas de la app), ni registrar, concluir o anular.
 * El endpoint les deja `vista=registro` y `vista=cierre-archivo` (el documento con que se concluyó una fila del
 * registro) y nada más, y solo GET: 403 `PROMOS_SOLO_REGISTRO` en todo lo demás.
 * TRADEMARKETING NO está aquí: entra desde db/205 con el registro y el ranking de cumplimiento, y la usuaria no le
 * quitó nada. La app del teléfono lleva COPIA de esta lista (`api.js`) para esconder su pestaña «Promos»; la compara
 * `promos-acceso.test.ts`.
 */
export const ROLES_PROMOS_SOLO_REGISTRO: readonly string[] = ['ANALISTATRADEMKT'];

/** Las vistas GET que forman el registro. */
export const VISTAS_DEL_REGISTRO_PROMOS: readonly string[] = ['registro', 'cierre-archivo'];

/** Los roles de Facturación: entran para CONCLUIR los registros de su empresa, y el enlace les sale en «Facturación». */
export const ROLES_FACTURACION_PROMOS: readonly string[] = ['FACTURACION', 'FACTURACIONDDH'];

/**
 * Las cuentas que registran como el ASESOR de un código sin tener el rol ASESOR. Key Accounts (Manuel Puerta) es
 * REGIONAL con el alcance ABIERTO (db/161: lee el portal entero) y es también quien lleva el 103 — sin esta lista,
 * las promos de sus 41 clientes (36 sucursales de cuentas clave) solo las podría registrar un Master. La usuaria
 * (2026-10-02): «ve todo y registra las del 103». Es la misma identidad que `CODIGO_DE_LA_CUENTA` en `diamante.mts`.
 */
export const REGISTRA_COMO_ASESOR: Readonly<Record<string, readonly string[]>> = {
  KEYACCOUNTS: ['103'],
};

/** Qué empresa cierra cada cuenta de Facturación (sus registros, y solo esos). */
export const FACTURACION_EMPRESA: Readonly<Record<string, 'DDH' | 'DHV' | 'DIF'>> = {
  FACTURACIONDDH: 'DDH',
  FACTURACIONDHV: 'DHV',
  FACTURACIONDIF: 'DIF',
};

export const esMaster = (roles: readonly string[]): boolean => roles.includes('MASTER');

export const puedeVerPromos = (roles: readonly string[] = []): boolean =>
  PROMOS_EN_PRUEBA ? esMaster(roles) : roles.some((r) => ROLES_PROMOS.includes(r));

/**
 * LOS COORDINADORES REGISTRAN (la usuaria, 2026-10-22: «los coordinadores también pueden colocar promociones, pueden
 * seleccionar clientes y pueden seleccionar y cargar las promociones»). Coordinador = rol REGIONAL con los códigos de
 * su zona en el alcance (Andes-Occidente 5, Centro-Llanos 11). La promo sigue siendo del ASESOR del cliente —su código
 * en el PRM, su meta y su presupuesto—; el coordinador queda como quien la registró.
 * Sin códigos NO registra por esta vía (falla cerrado): es Key Accounts, que lee el portal entero (db/161) y sigue en
 * `REGISTRA_COMO_ASESOR` con el 103, o un coordinador al que se le borró la zona — abrirle «todo» sería darle el país.
 */
export const codigosQueCoordina = (roles: readonly string[], codigos: readonly string[] | null | undefined): readonly string[] =>
  !esMaster(roles) && roles.includes('REGIONAL') && codigos?.length ? codigos : [];

/** ¿Registra promos en general? El ASESOR (su cartera), el coordinador (su zona), las de `REGISTRA_COMO_ASESOR` (su
 *  código) y Master. `codigos` = los vendedores del alcance de la sesión. */
export const puedeRegistrarPromo = (roles: readonly string[] = [], username = '', codigos: readonly string[] | null = null): boolean =>
  PROMOS_EN_PRUEBA ? esMaster(roles)
    : roles.includes('ASESOR') || esMaster(roles) || codigosQueCoordina(roles, codigos).length > 0
      || !!REGISTRA_COMO_ASESOR[username.toUpperCase()];

/**
 * ¿Registra las promos de ESTE cliente (el de `vendedorCod`)? Al asesor ya lo acota su alcance (solo ve su cartera);
 * al coordinador, los códigos de su zona; a Key Accounts, que lo ve todo, su código.
 */
export function puedeRegistrarCliente(roles: readonly string[], username: string, vendedorCod: string | null,
  codigos: readonly string[] | null = null): boolean {
  if (PROMOS_EN_PRUEBA) return esMaster(roles);
  if (esMaster(roles) || roles.includes('ASESOR')) return true;
  if (!vendedorCod) return false;
  if (codigosQueCoordina(roles, codigos).includes(vendedorCod)) return true;
  const propios = REGISTRA_COMO_ASESOR[username.toUpperCase()];
  return !!propios && propios.includes(vendedorCod);
}

/** Facturación (sin ser Master): ve y concluye los registros de su empresa, y no la pestaña de presupuesto. */
export const esFacturacionPromos = (roles: readonly string[]): boolean =>
  !esMaster(roles) && roles.some((r) => ROLES_FACTURACION_PROMOS.includes(r));

/** Ve SOLO el registro (db/245): tiene un rol de `ROLES_PROMOS_SOLO_REGISTRO` y ninguno que vea más. Manda el rol que
 *  más puede: si el usuario trae además otro rol de `ROLES_PROMOS`, entra con lo de ese. */
export const soloRegistroPromos = (roles: readonly string[] = []): boolean =>
  !esMaster(roles) && roles.some((r) => ROLES_PROMOS_SOLO_REGISTRO.includes(r))
  && !roles.some((r) => ROLES_PROMOS.includes(r) && !ROLES_PROMOS_SOLO_REGISTRO.includes(r));

/** ¿Puede usar esa vista con ese método? Para todos menos los de solo registro, sí (cada rama lleva su candado). */
export const puedeUsarVistaPromos = (roles: readonly string[], metodo: string, vista: string): boolean =>
  !soloRegistroPromos(roles) || (metodo === 'GET' && VISTAS_DEL_REGISTRO_PROMOS.includes(vista));

/** La pestaña «Presupuesto»: ni Facturación (db/205) ni quien ve solo el registro (db/245). */
export const vePresupuestoPromos = (roles: readonly string[]): boolean =>
  !esFacturacionPromos(roles) && !soloRegistroPromos(roles);

/**
 * CUMPLIMIENTO DE LA META DE PROMOCIONES (db/206, la usuaria el 2026-10-02). La meta es la de la maqueta («Metas por
 * asesor»); vendida = cada promo REGISTRADA en el mes; cada mes desde cero. Los coordinadores compiten: meta = suma de
 * sus asesores y gana el que más promos sume. Quién ve qué (NORMA 1):
 *  · el ASESOR, solo lo suyo y sin ranking;
 *  · el COORDINADOR (rol REGIONAL), sus asesores, su total, su % y su PUESTO, sin las cifras de los otros
 *    coordinadores. Key Accounts entra aquí como coordinador del 103 (`REGISTRA_COMO_ASESOR`), aunque en el resto
 *    del portal lea todo (db/161): con el ranking abierto podría sumar las zonas de los demás;
 *  · Gerencia de Ventas, C.E.I., Trade Marketing y Master, todo y el ranking entero;
 *  · Facturación no la ve: entra a concluir los registros de su empresa.
 */
export const veCumplimientoPromos = (roles: readonly string[]): boolean =>
  puedeVerPromos(roles) && !esFacturacionPromos(roles) && !soloRegistroPromos(roles);

export const esCoordinadorPromos = (roles: readonly string[]): boolean => !esMaster(roles) && roles.includes('REGIONAL');

/** El ranking ENTERO de coordinadores: quien ve todo el portal de ventas y no compite en él. */
export const veRankingCompleto = (roles: readonly string[]): boolean =>
  veCumplimientoPromos(roles) && (esMaster(roles) || (!roles.includes('ASESOR') && !roles.includes('REGIONAL')));

/** Puesto con empates (1, 1, 3): a igual cantidad de promos, igual puesto — al empezar el mes todos van 1.º. */
export function puestosPorCantidad<T extends { vendidas: number }>(filas: readonly T[]): (T & { puesto: number })[] {
  const ord = [...filas].sort((a, b) => b.vendidas - a.vendidas);
  return ord.map((f) => ({ ...f, puesto: ord.findIndex((x) => x.vendidas === f.vendidas) + 1 }));
}

/**
 * En qué módulos del menú sale el enlace. La página cuelga de TRES (db/205: `comercial`, `fact` y `tmk` para Trade
 * Marketing, que no tiene `comercial`). Desde el 2026-10-08 sale en «Facturación» para TODO el que tenga ese módulo
 * —Facturación y los Master— (la usuaria: «que la sección de promociones aparezca en el módulo de facturación»); los
 * demás la siguen viendo en Comercial y, si no lo tienen, en Trade Marketing. Facturación, solo en el suyo (aunque
 * FACTURACIONDDH tenga `comercial`). Vacío = no la ve.
 */
export function modulosDelEnlacePromos(roles: readonly string[], modulos: readonly string[]): string[] {
  if (!puedeVerPromos(roles)) return [];
  const fuera: string[] = [];
  if (!esFacturacionPromos(roles)) {
    if (modulos.includes('comercial')) fuera.push('comercial');
    else if (modulos.includes('tmk')) fuera.push('tmk');
  }
  if (modulos.includes('fact')) fuera.push('fact');
  return fuera;
}

/** Dar por concluido un registro de la empresa `empresa`. */
export const puedeCerrarPromo = (username: string, roles: readonly string[], empresa: string): boolean =>
  esMaster(roles) || FACTURACION_EMPRESA[username] === empresa;

/** Almacén y Despacho solo ve los registros con producto de regalo (que es lo único que le avisa). */
export const soloConRegalo = (roles: readonly string[]): boolean =>
  roles.includes('ALMACENYDESPACHO') && !esMaster(roles);

export const EMPRESA_NOMBRE: Readonly<Record<string, string>> = {
  DDH: 'Distribuidora Díaz Hernández', DHV: 'DH Vital', DIF: 'Difranca',
};

export const CAMPANA_NOMBRE: Readonly<Record<string, string>> = {
  trim: 'Trimestre', oct: 'Octubre', bf: 'Black Friday', nav: 'Navidad',
};

export const MARCA_NOMBRE: Readonly<Record<number, string>> = {
  5: 'Pasarela', 3: 'HD Cosmetic´s', 6: 'Quick Fix', 2: 'GA.MA',
};

/** Un monto escrito a mano. Con coma, la coma es el decimal y los puntos son miles («1.234,56»); sin coma, un único
 *  punto con 1-2 cifras detrás es el decimal («12.50») y si no, son miles («1.250»). Lo que no se lee da NaN. */
export function leerMonto(t: string): number {
  const s = t.trim().replace(/[\s$]/g, '');
  if (!s || !/^[\d.,]+$/.test(s)) return NaN;
  if (s.includes(',')) return (s.match(/,/g) ?? []).length > 1 ? NaN : Number(s.replace(/\./g, '').replace(',', '.'));
  const partes = s.split('.');
  if (partes.length === 2 && partes[1]!.length <= 2) return Number(s);
  return Number(s.replace(/\./g, ''));
}
